<template>
  <v-container>
    <v-layout row align-center class="my-3">
      <v-icon class="my-1" color="primary">supervisor_account</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Relaciones de Parentesco</span>
    </v-layout>
      <div class="decretosBoton">
        <v-menu bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small tile outline color="primary">
              <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
          </template>
          <v-card class="px-2 py-1">
            <v-card-text class="black--text body-2">
              <v-icon small color="info">info</v-icon>&nbsp;
              <span><b>Tipo de parentesco:</b> Registrar sólo los datos de los parientes con vida que residan en el país o en el extranjero, hasta el segundo grado de consanguinidad y/o afinidad como ser: padre, madre abuelos, hijos, nietos, hermanos, suegros, cuñados, yernos y nueras. 
              <br>
              <v-icon small color="info">info</v-icon>&nbsp;
              <b>Número de documento de identidad: </b> 
              Cuando el(a) declarante no cuente con el número de cédula de identidad del(os) pariente(s) puede prescindirse de este dato, manteniendo la obligatoriedad del registro de los nombres y apellidos de los parientes, así como el grado de parentesco. 
            </span>
            </v-card-text>
          </v-card>
        </v-menu>
        </div>
        <v-flex xs12 sm12 md12 class="decretos">
          <alert-extendible texto="<b>Tipo de parentesco:</b> Registrar sólo los datos de los parientes con vida que residan en el país o en el extranjero, hasta el segundo grado de consanguinidad y/o afinidad como ser: padre, madre abuelos, hijos, nietos, hermanos, suegros, cuñados, yernos y nueras.  <br>
            <b>Número de documento de identidad: </b> Cuando el(a) declarante no cuente con el número de cédula de identidad del(os) pariente(s) puede prescindirse de este dato, manteniendo la obligatoriedad del registro de los nombres y apellidos de los parientes, así como el grado de parentesco. "></alert-extendible>
          <!-- <v-alert align='justify'
            :value='true'
            color='info'
            icon='info'
            outline>
            <b>Tipo de parentesco:</b> Se debe registrar solo los datos de los parientes con vida que residan en el país o en el extranjero, hasta el segundo grado de consanguinidad y/o afinidad como ser: padre, madre abuelos, hijos, nietos, hermanos, suegros, cuñados, yernos y nueras.
            <br>
            <b>Número de documento de identidad: </b> 
              Cuando el(a) declarante no cuente con el número de cédula de identidad del(os) pariente(s) puede prescindirse de este dato, manteniendo la obligatoriedad del registro de los nombres y apellidos de los parientes, así como el grado de parentesco.
            </v-alert> -->
        </v-flex> 
      <v-layout justify-end>
        <v-btn color='success' dark @click.stop='dialog = true'>
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model='valid' ref='form' lazy-validation>
        <v-dialog v-model='dialog' scrollable max-width='900' persistent>
          <v-card>
            <v-toolbar dark color='primary' right>
              <v-toolbar-title><h4>Relaciones de Parentesco</h4></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click='cancel()'>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md12 v-show="!deleteMode" class='decretos'>
                    <alert-extendible texto="Registrar solamente los parientes con vida, como ser: padre, madre, abuelos, hijos, nietos, hermanos, suegros, cuñados, yernos y nueras."></alert-extendible>
                  </v-flex>
                  <v-flex xs12 md12 v-show='deleteMode'>
                    <v-alert
                      :value='true'
                      type='warning'                      
                      outline
                    >¿Está seguro de eliminar la relación de parentesco siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md6>
                    <v-autocomplete
                    :no-data-text="$t('comun.sin_resultados_busqueda')"
                      v-model='tipoParentesco'
                      :items='itemsTipoParentesco'
                      item-text='tippar_descripcion'
                      item-value='tippar_codigo'
                      label='Parentesco*'
                      :rules='dRules'
                      required
                      :disabled='this.deleteMode'
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm6 md6>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator='{ on }'>
                        <v-text-field
                          v-on='on'
                          v-model='nroDocumento'
                          label='Número de Documento'
                          maxlength='40'
                          :rules='nroDocumentoRules'
                          :disabled='deleteMode'            
                        ></v-text-field>
                      </template>
                      <span>Digite el número del documento de identificación(SIN ESPACIOS VACIOS)</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex sm6 md6>
                    <v-autocomplete
                    :no-data-text="$t('comun.sin_datos')"
                      v-model='lugarExpedicion'
                      :items='itemsLugarExpedicion'
                      label='Lugar de expedicion'
                      item-text='dep_descripcion'
                      item-value='dep_codigo'
                      :disabled='this.deleteMode'
                      v-show='false'
                      clearable
                    ></v-autocomplete>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator='{ on }'>
                        <v-text-field
                          v-on='on'
                          v-model='complemento'
                          :rules='complementoRules'
                          label='Complemento SEGIP'
                          maxlength='2'
                          :disabled='deleteMode'
                          class="text-normal"
                        ></v-text-field>
                      </template>
                      <span>Llene este campo solo si tiene el complemento otorgado por SEGIP</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <v-layout wrap>
                  <v-flex sm6 md4>
                    <v-text-field
                      v-model='apellidoPaterno'
                      label='Apellido Paterno'
                      :disabled='this.deleteMode'
                      maxlength='55'
                      :rules="$validate(['text_area'])"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 md4>
                    <v-text-field
                      v-model='apellidoMaterno'
                      label='Apellido Materno'
                      :disabled='this.deleteMode'
                      maxlength='55'
                      :rules="$validate(['text_area'])"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm6 md4>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator='{ on }'>
                        <v-text-field
                          v-on='on'
                          v-model='nombres'
                          :rules='textRules'
                          label='Nombres*'
                          required
                          maxlength='55'
                          :disabled='deleteMode'
                        ></v-text-field>
                      </template>
                      <span>Revise sus Apellidos y Nombres que esten transcritos correctamente.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm6 md4>
                    <div
                      class='v-label theme--light error--text'
                      v-show='codErrorApellido !== null'
                    >{{this.msgApellido}}</div>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
                    <v-textarea
                      @change="observaciones = $util.sanitiza(observaciones)"
                      v-model='observaciones'
                      label='Observaciones'
                      :disabled='deleteMode'
                      counter
                      maxlength='250'
                      v-on='on'
                      hint='Máximo 250 caracteres.'
                      persistent-hint
                      :rules="$validate(['text_area'])"
                      rows="1"
                      auto-grow
                    ></v-textarea>
                     </template>
            <span> Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de “Relaciones de parentesco”.
</span>
          </v-tooltip>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class='plomo--text'>Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
                <v-layout wrap>
                <v-flex sm12 md12>
                  <v-subheader v-show='!deleteMode'>
                    <strong><p class='light-green--text'>El proceso de validación con el Segip es opcional, siendo útil para confirmar la escritura de los nombres según el documento de identidad.</p></strong>
                  </v-subheader>
                </v-flex>
              </v-layout>
              <v-card-actions>
              <v-spacer></v-spacer>
                  <v-btn color='validate' class="v-btn__content_validar" @click='verificaHabilitacion()' v-show='!deleteMode'><v-icon>beenhere</v-icon>&nbsp;Validar</v-btn>
                  <v-btn color='primary' :loading='loadingButton' @click='preVerificacion()'><div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div><div v-else><v-icon>save</v-icon>&nbsp;Guardar</div></v-btn>
                  <v-btn color='error' @click='cancel()'><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
            </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout>
        <v-dialog v-model='dialogHabilitar' scrollable persistent max-width='700px'>
          <v-card>
            <v-card-title><h4><v-icon color="yellow">warning</v-icon>Advertencia</h4></v-card-title>
            <v-card-text wrap>
              <v-flex sm12 md12>
                <strong><p class='light-green--text'>El llenado de los campos Nacionalidad y Fecha de Nacimiento, son para la validación con el SEGIP, los campos mencionados no son registrados</p></strong>
              </v-flex>
              <v-layout wrap>
                <v-flex sm6 md6>
                  <v-select
                  :no-data-text="$t('comun.sin_datos')"
                    v-model='tipoNacionalidad'
                    :items='itemTipoNacionalidad'
                    item-text='tipoNacionalidad_descripcion'
                    item-value='tipoNacionalidad_codigo'
                    label='Nacionalidad'
                    color='light-green'
                    hint='Dato opcional para validar'
                    persistent-hint
                    teal
                    required
                  ></v-select>
                </v-flex>
                <v-flex sm6 md6>
                  <global-date-input-picker
                    v-model="date" :hint="'Formato : DD/MM/AAAA (Dato opcional para validar)'" label="Fecha de Nacimiento*">
                  </global-date-input-picker> 
                </v-flex>
              </v-layout>
              <p>Digite la letras y/o números que aparecen en la imagen </p>
              <v-layout row wrap>
                <v-flex md3 offset-md1>
                  <img
                    :src="imgb64"
                    alt="Bolivia">
                </v-flex>
                <v-flex md3 offset-md1>
                  <v-text-field
                    v-model="captcha"
                    label='Respuesta'
                    :rules='this.useCaptcha ? dRules : []'
                    :required="this.useCaptcha"
                    :maxlength="this.lengthCaptcha"
                    @keydown.enter="login()"
                  ></v-text-field>
                </v-flex>
                <v-flex md1>
                  <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading='loadingButtonValidar' color='primary' @click='validar()'>
                <v-icon>check</v-icon>&nbsp;Continuar
              </v-btn>
              <v-btn color='error' @click='dialogHabilitar=false'>
                <v-icon>cancel</v-icon>&nbsp;Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert :value='true' :type='statusError' v-show='codError !== null'>{{this.msgError}}</v-alert>
        </v-flex>
        <v-flex xs12 v-if='this.nro>0'>
          <v-data-table
            :headers='headers'
            :items='datos'
            class='elevation-1'
            rows-per-page-text='Filas por página'
            :rows-per-page-items='rowsPerPageItems'
          >
            <template slot='no-data'>
              <v-alert
              class="tamanioBoton"
                :value='true'
                color='info'
                outline
                icon='info'
              >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
            </template>
            <template slot='items' slot-scope='props'>
              <td>{{ props.item.nro }}</td>
              <td class='justify-center layout px-0'>
                <v-btn icon class='mx-0' @click='editItem(props.item)'>
                  <v-icon color='blue'>edit</v-icon>
                </v-btn>
                <v-btn icon class='mx-0' @click='deleteItem(props.item)'>
                  <v-icon color='red'>delete</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.tippar_descripcion }}</td>
              <td>{{ props.item.par_paterno }}</td>
              <td>{{ props.item.par_materno }}</td>
              <td>{{ props.item.par_nombres }}</td>
              <td>{{ props.item.par_docidentidad }}</td>
              <td><text-extendible :texto='props.item.par_observacion'></text-extendible></td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 v-else>
          <v-alert class="tamanioBoton" :value='true' color='info' icon='info'>NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
      </v-layout>
      <v-layout align-center wrap v-if="tipo_usuario !== 'usuario_externo'">
        <v-flex md8 />
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click="$router.push('/deudas')">
            <v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior
          </v-btn>
          <v-btn color='accent' @click="$router.push('/borrador')">
            Siguiente&nbsp;
            <v-icon right dark>arrow_forward_ios</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout align-center wrap v-if="tipo_usuario === 'usuario_externo'">
        <v-flex md8 />
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click="$router.push('/deudas')">
            <v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior
          </v-btn>
          <v-btn color='accent' @click="$router.push('/apoderado')">
            Siguiente&nbsp;
            <v-icon right dark>arrow_forward_ios</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title><h4><v-icon color="yellow">warning</v-icon>Advertencia</h4></v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="repetidosModal = false, guardar()"><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn color="error" flat @click="repetidosModal = false, cancel()"><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
  </v-container>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
import jsonQuery from 'json-query';
import Captcha from '../portal/mixins/captcha.js';
export default {
  mixins: [Parametricas, Captcha, validate],
  created () {
    this.crearImagenCaptcha();
    // this.navBarEmmit();
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning'](
            'Su ultima Declaración no fue recepcionada, habilite la misma para terminarla'
          );
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
    if (this.$storage.get('ex') === 1) {
      this.$service.get('departamentos', {}).then(res => {
        if (res) {
          this.itemsLugarExpedicion = res;
        }
      });
      this.obtenerParentescoAnteriores();
      this.obtenerParentesco();
      let token = this.$util.parseJwt(this.$storage.get('token'));
      this.tipo_usuario = token.tipo;
    }
  },
  data: () => ({
    loadingButton: false,
    loadingButtonValidar: false,
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      { text: 'Parentesco', sortable: false, value: 'tippar_descripcion' },
      { text: 'Paterno', sortable: false, value: 'par_paterno' },
      {
        text: 'Materno',
        sortable: false,
        value: 'par_materno'
      },
      {
        text: 'Nombres',
        sortable: false,
        value: 'par_nombres'
      },
      {
        text: 'Cédula de Identidad',
        sortable: false,
        value: 'par_docidentidad'
      },
      { text: 'Observación', sortable: false, value: 'par_observacion' }
    ],
    datos: [],
    tipo_usuario: '',
    tipoDocumento: 1, // 1: Cedula de identidad ; Para todos los registros estara con este tipo de documento
    tipoParentesco: 0,
    itemsTipoParentesco: null,
    lugarExpedicion: 0,
    rowsPerPageItems: [5, 10, 25, { text: 'Todo', value: -1 }],
    itemsLugarExpedicion: null,
    tipoNacionalidad: 0,
    itemTipoNacionalidad: [
      {
        tipoNacionalidad_descripcion: 'NACIONAL',
        tipoNacionalidad_codigo: '1'
      },
      {
        tipoNacionalidad_descripcion: 'EXTRANJERO',
        tipoNacionalidad_codigo: '2'
      }
    ],
    fechaNacDbFormat: '', // new Date().toISOString().substr(0, 10),
    menu: false,
    nroDocumento: '',
    nroDocumentoComplemento: '',
    complemento: '',
    control: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    nombres: '',
    observaciones: '',
    codParentesco: 0,
    nro: 0,
    dialog: false,
    editMode: false,
    deleteMode: false,
    codError: null,
    msgError: null,
    statusError: null,
    dialogHabilitar: false,
    maskFecha: '##/##/####',
    fechaNacimiento: '',
    sw: 0,
    nroCiPasaporte: '',
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    nroDocumentoRules: [
      v => /^[A-Za-z0-9-]*$/.test(v) || 'El número de documento no es válido'
    ],
    complementoRules: [
      v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
      v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
    ],
    valid: true,
    msgApellido: null,
    codErrorApellido: null,
    codRptaSegip: null,
    msgErrorSegip: null,
    repetidosModal: false,
    date: '',
    imgb64: '',
    captcha: '',
    tokenCaptcha: '',
    useCaptcha: process.env.USE_CAPTCHA,
    lengthCaptcha: process.env.LENGTH_CAPTCHA
  }),
  methods: {
    async crearImagenCaptcha () {
      this.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    obtenerParentescoAnteriores () {
      this.$service.get(`djbr_registro/parentesco/2`, {}).then(response => {
        this.nro = 0;
        if (response.length >= 1 && response[0].par_codigo !== -1) {
          this.datos = response;
          for (let i = 0; i < this.datos.length; i++) {
            this.datos[i].nro = ++this.nro;
          }
        } else {
          this.datos = [];
        }
      });
    },
    obtenerParentesco () {
      this.$service.get(`tipos_parentesco`, {}).then(response => {
        if (response) {
          this.itemsTipoParentesco = response;
        }
      });
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.reinicializa();
      this.loadingButton = false;
    },
    preVerificacion () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.complemento === 'lp' || this.complemento === 'cb' || this.complemento === 'sc' ||
            this.complemento === 'pt' || this.complemento === 'or' || this.complemento === 'ch' ||
            this.complemento === 'tj' || this.complemento === 'bn' || this.complemento === 'pn') {
          this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
          this.complemento = '';
        }
        if (this.$refs.form.validate() && this.validarFormato() === 1) {
          this.loadingButton = true;
          if (
            (this.apellidoPaterno !== '' && this.apellidoMaterno === '') ||
            (this.apellidoPaterno === '' && this.apellidoMaterno !== '') ||
            (this.apellidoPaterno !== '' && this.apellidoMaterno !== '')) {
            if (this.verificarRepetidos() && !this.deleteMode) {
              this.repetidosModal = true;
            } else {
              this.guardar();
            }
          } else {
            this.codErrorApellido = 0;
            this.$message['warning']('Debe ingresar al menos un Apellido');
            this.loadingButton = false;
          }
        } else if (!this.$refs.form.validate()) {
          this.$message['warning']('Por Favor revise los datos requeridos..');
        }
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        this.save();
      }
    },
    save () {
      if (this.complemento !== '') {
        this.nroDocumentoComplemento =
          this.nroDocumento + '-' + this.complemento;
      } else {
        this.nroDocumentoComplemento = this.nroDocumento;
      }
      let params = {
        tipo_documento: this.tipoDocumento,
        tipo_parentesco: this.tipoParentesco,
        nro_documento: this.nroDocumentoComplemento,
        cod_lugar_exp: this.lugarExpedicion,
        apellido_paterno: this.apellidoPaterno,
        apellido_materno: this.apellidoMaterno,
        nombres: this.nombres,
        observaciones: this.observaciones
      };
      this.$service
        .post(`djbr_registro/parentesco`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerParentescoAnteriores();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    editItem (item) {
      this.reinicializa();
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    update () {
      if (this.complemento !== '') {
        this.nroDocumentoComplemento =
          this.nroDocumento + '-' + this.complemento;
      } else {
        this.nroDocumentoComplemento = this.nroDocumento;
      }
      let params = {
        cod_parentesco: this.codParentesco,
        tipo_documento: this.tipoDocumento,
        tipo_parentesco: this.tipoParentesco,
        nro_documento: this.nroDocumentoComplemento,
        cod_lugar_exp: this.lugarExpedicion,
        apellido_paterno: this.apellidoPaterno,
        apellido_materno: this.apellidoMaterno,
        nombres: this.nombres,
        observaciones: this.observaciones
      };
      this.$service
        .put(`djbr_registro/parentesco`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerParentescoAnteriores();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    reinicializa () {
      this.codParentesco = 0; // id
      this.tipoParentesco = 0;
      this.lugarExpedicion = 0;
      this.nroDocumento = '';
      this.complemento = '';
      this.tipoNacionalidad = 0;
      this.fechaNacDbFormat = '';
      this.apellidoPaterno = '';
      this.apellidoMaterno = '';
      this.nombres = '';
      this.observaciones = '';
      this.codErrorApellido = null;
      this.nroDocumentoComplemento = '';
      this.fechaNacimiento = '';
      this.date = '';
      this.$refs.form.resetValidation();
    },
    delete () {
      this.$service
        .delete('djbr_registro/parentesco/' + this.codParentesco)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerParentescoAnteriores();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codParentesco = item.par_codigo;
      this.tipoParentesco = item.tippar_codigo;
      this.lugarExpedicion = item.dep_codigo;
      this.control = item.par_docidentidad.substring(
        item.par_docidentidad.length - 3,
        item.par_docidentidad.length - 2
      );
      this.codErrorApellido = null;
      if (this.control === '-') {
        this.nroDocumento = item.par_docidentidad.substring(
          0,
          item.par_docidentidad.length - 3
        );
        this.complemento = item.par_docidentidad.substring(
          item.par_docidentidad.length - 2,
          item.par_docidentidad.length
        );
      } else {
        this.nroDocumento = item.par_docidentidad; // response.par_docidentidad;
      }
      this.tipoNacionalidad = 0;
      this.fechaNacDbFormat = ''; // por defecto
      this.apellidoPaterno = item.par_paterno;
      this.apellidoMaterno = item.par_materno;
      this.nombres = item.par_nombres;
      this.observaciones = item.par_observacion;
    },
    validar () {
      this.loadingButtonValidar = true;
      this.fechaNacimiento = this.date;
      if (this.tipoNacionalidad === 0 || this.fechaNacimiento === '' || this.fechaNacimiento === null) {
        this.showMessage(
          'warning',
          '<b>Para realizar la validación</b><br>Debe ingresar el tipo de Nacionalidad, el Número de Documento y Fecha de Nacimiento'
          );
        this.loadingButtonValidar = false;
      } else {
        if (this.complemento !== '' && this.nroDocumento !== '') {
          this.nroDocumentoComplemento = this.nroDocumento + '-' + this.complemento;
        } else {
          this.nroDocumentoComplemento = this.nroDocumento;
        }
        let params = {
          tipo_persona: this.tipoNacionalidad,
          NumeroDocumento: this.nroDocumentoComplemento,
          FechaNacimiento: this.fechaNacimiento,
          PrimerApellido: this.apellidoPaterno,
          SegundoApellido: this.apellidoMaterno,
          nombres: this.nombres,
          token: this.tokenCaptcha,
          captcha: this.captcha
        };
        this.$service
        .post(`djbr_registro/contrastacion_segip`, params)
        .then(responseSegip => {
          if (responseSegip) {
            if (responseSegip.err_existente === 0) {
              this.$message['success'](responseSegip.err_mensaje);
              responseSegip.finalizado = true;
              this.dialogHabilitar = false;
              this.loadingButtonValidar = false;
            }
            if (responseSegip.err_existente === 1) {
              this.$message['info'](responseSegip.err_mensaje);
              responseSegip.finalizado = false;
              this.loadingButtonValidar = false;
              this.crearImagenCaptcha();
            }
            if (responseSegip.error_codigo === 503) {
              this.$message['info']('El servicio de contrastación no está disponible, se continuará sin esta verificación.', 'SEGIP', {timeout: 15000});
              responseSegip.finalizado = true;
              this.dialogHabilitar = false;
              this.loadingButtonValidar = false;
            }
          } else {
            this.crearImagenCaptcha();
            this.loadingButtonValidar = false;
          }
        }).catch(e => {
          this.crearImagenCaptcha();
          console.log(e);
          this.loadingButtonValidar = false;
        });
      }
    },
    showMessage (type, men) {
      this.$message[type](`${men}`);
    },
    verificaHabilitacion () {
      if (this.$refs.form.validate() && this.validarFormato() === 1 && !!this.nroDocumento) {
        if (this.apellidoPaterno !== '' || this.apellidoMaterno !== '') {
          this.dialogHabilitar = true;
        } else {
          this.codErrorApellido = 0;
          this.$message['warning']('Debe ingresar al menos un Apellido');
        }
      } else {
        if (!this.$refs.form.validate()) {
          this.$message['warning']('Por Favor revise los datos requeridos..');
        }
        if (this.nroDocumento === '') {
          this.$message['warning']('Debe ingresar el Número de Documento para realizar la validación..');
        }
      }
    },
    validarFormato () {
      if (/^[0-9]*$/.test(this.nroDocumento)) {
        this.sw = 1;
      } else if (/^[A-Za-z0-9]{1,4}-[0-9]{1,10}$/.test(this.nroDocumento)) {
        this.sw = 1;
      } else {
        this.sw = 0;
      }
      if (this.sw === 0) {
        this.showMessage(
        'warning',
        '<b>Formato Incorrecto en Número de documento</b><br><b>CI</b> Solo digite numeros<br><b>Número de Pasaporte</b> El formato es el codigo separado por guion y numeros Ej. A-1233'
        );
      } return this.sw;
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        tipo_parentesco: this.tipoParentesco,
        nro_documento: this.nroDocumentoComplemento.toUpperCase().trim(),
        apellido_paterno: this.apellidoPaterno.toUpperCase().trim(),
        apellido_materno: this.apellidoMaterno.toUpperCase().trim(),
        nombres: this.nombres.toUpperCase().trim()
      };
      let resultQuery = jsonQuery(`lista[*tippar_codigo=${comparing.tipo_parentesco} & 
                                   par_docidentidad=${comparing.nro_documento} &
                                   par_paterno=${comparing.apellido_paterno} &
                                   par_materno=${comparing.apellido_materno} &
                                   par_nombres=${comparing.nombres}]`, { data });
      return resultQuery.value.length > 0;
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
};
</script>
<style lang='scss'>
.txt-danger {
  color: #f55656;
}
.txt-info {
  color: #5484cc;
}
.v-btn__content_validar {
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/declaracion/parentesco.vue